import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../auth.service";
import { Router } from "@angular/router";
import { PasswordService } from "../../services/reset-password.service";
import { BehaviorSubject } from "rxjs";
import { Messages } from "../../model/messages";
import { ActionButtonSubmit } from "../../model/action-button-submit";

@Component({
  selector: "forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.css"],
})
export class ForgotPasswordComponent {
  form: FormGroup;
  submitted = false;
  emailSent = false;
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);
  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private passwordService: PasswordService
  ) {
    this.form = this.fb.group({
      username: ["", [Validators.required, Validators.minLength(2)]],
    });
  }
  onSubmit(action?: ActionButtonSubmit) {
    if (this.form.valid) {
      const username = this.form.value.username;

      this.passwordService.sendResetLink(username).subscribe(
        (messages) => {
          if (messages.empty) {
            this.emailSent = true;
            this.messages.next(Messages.EMPTY);
            action?.result(true);
          } else {
            this.messages.next(messages);
            action?.result(false);
          }
        },
        (error) => {
          this.messages.next(
            Messages.from({ username: ["forgotPassword.error"] })
          );
          action?.result(false);
        }
      );
    } else {
      this.form.markAllAsTouched();
      action?.result(false);
    }
  }
  logout(): void {
    this.auth.logout();

    this.router.navigate(["/login"]);
  }
  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }
}
